export default __webpack_public_path__ + "img/all-access-rewards-card-472cb2409d36606f5b97b3943099797b.png";